import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=6003da8f&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6003da8f')) {
      api.createRecord('6003da8f', component.options)
    } else {
      api.reload('6003da8f', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=6003da8f&", function () {
      api.rerender('6003da8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P4lnR0dAT7V1/JS/imageCarousel.vue"
export default component.exports